import { GridColDef } from '@mui/x-data-grid-pro';
import { GridEventListener } from '@mui/x-data-grid';
import { GridFilterModel, GridRowSelectionModel, GridCallbackDetails } from '@mui/x-data-grid/models';
import { GridColumnVisibilityModel } from '@cbridge-utils/datagrid';

export enum RuleStatus {
  Added = 'added',
  Updated = 'updated',
  Deleted = 'deleted',
}

export enum RuleValidity {
  Error = 'error',
  Unused = 'unused',
  Useless = 'useless',
}

export interface IRuleRowModel {
  id: number;
  index: number;
  originalIndex?: number;
  status?: RuleStatus;
  validity?: RuleValidity;
  // Synthetic read-only last row showing what applies when no rule matches. Never persisted.
  isDefault?: boolean;
}

export interface IRulesGridProps<R extends IRuleRowModel> {
  /** Page prefix of the persisted column order/widths (`{settingsKey}.datagrid.columns`). */
  settingsKey?: string;
  columns: GridColDef<R>[];
  rows: R[];
  columnVisibilityModel?: GridColumnVisibilityModel<R>;
  filterModel?: GridFilterModel;
  isEditable?: boolean;
  isLoading?: boolean;
  onRowOrderChange?: GridEventListener<'rowOrderChange'>;
  processRowUpdate?: (newRow: R, oldRow: R) => Promise<R> | R;
  rowSelectionModel?: GridRowSelectionModel;
  onRowSelectionModelChange?: (rowSelectionModel: GridRowSelectionModel, details: GridCallbackDetails) => void;
  onFilteredCountChange?: (filteredCount: number) => void;
}
